(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlinx-serialization-kotlinx-serialization-core.js', './kotlin-kotlin-stdlib.js', './fixers-s2-s2-automate-s2-automate-dsl.js', './fixers-f2-f2-dsl-f2-dsl-cqrs.js', './boislocal-platform-platform-infra-commons-commons-domain.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./kotlin-kotlin-stdlib.js'), require('./fixers-s2-s2-automate-s2-automate-dsl.js'), require('./fixers-f2-f2-dsl-f2-dsl-cqrs.js'), require('./boislocal-platform-platform-infra-commons-commons-domain.js'));
  else {
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-referential-removalZoneCertification-removalZoneCertification-domain'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'boislocal-platform-platform-s2-referential-removalZoneCertification-removalZoneCertification-domain'.");
    }
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-referential-removalZoneCertification-removalZoneCertification-domain'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'boislocal-platform-platform-s2-referential-removalZoneCertification-removalZoneCertification-domain'.");
    }
    if (typeof this['fixers-s2-s2-automate-s2-automate-dsl'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-referential-removalZoneCertification-removalZoneCertification-domain'. Its dependency 'fixers-s2-s2-automate-s2-automate-dsl' was not found. Please, check whether 'fixers-s2-s2-automate-s2-automate-dsl' is loaded prior to 'boislocal-platform-platform-s2-referential-removalZoneCertification-removalZoneCertification-domain'.");
    }
    if (typeof this['fixers-f2-f2-dsl-f2-dsl-cqrs'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-referential-removalZoneCertification-removalZoneCertification-domain'. Its dependency 'fixers-f2-f2-dsl-f2-dsl-cqrs' was not found. Please, check whether 'fixers-f2-f2-dsl-f2-dsl-cqrs' is loaded prior to 'boislocal-platform-platform-s2-referential-removalZoneCertification-removalZoneCertification-domain'.");
    }
    if (typeof this['boislocal-platform-platform-infra-commons-commons-domain'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-referential-removalZoneCertification-removalZoneCertification-domain'. Its dependency 'boislocal-platform-platform-infra-commons-commons-domain' was not found. Please, check whether 'boislocal-platform-platform-infra-commons-commons-domain' is loaded prior to 'boislocal-platform-platform-s2-referential-removalZoneCertification-removalZoneCertification-domain'.");
    }
    root['boislocal-platform-platform-s2-referential-removalZoneCertification-removalZoneCertification-domain'] = factory(typeof this['boislocal-platform-platform-s2-referential-removalZoneCertification-removalZoneCertification-domain'] === 'undefined' ? {} : this['boislocal-platform-platform-s2-referential-removalZoneCertification-removalZoneCertification-domain'], this['kotlinx-serialization-kotlinx-serialization-core'], this['kotlin-kotlin-stdlib'], this['fixers-s2-s2-automate-s2-automate-dsl'], this['fixers-f2-f2-dsl-f2-dsl-cqrs'], this['boislocal-platform-platform-infra-commons-commons-domain']);
  }
}(this, function (_, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_kotlin, kotlin_io_komune_s2_s2_automate_dsl, kotlin_io_komune_f2_f2_dsl_cqrs, kotlin_org_boislocal_commons_domain) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var createSimpleEnumSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c2;
  var LazyThreadSafetyMode_PUBLICATION_getInstance = kotlin_kotlin.$_$.i;
  var lazy = kotlin_kotlin.$_$.ge;
  var protoOf = kotlin_kotlin.$_$.fa;
  var SerializerFactory = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b2;
  var objectMeta = kotlin_kotlin.$_$.ea;
  var setMetadataFor = kotlin_kotlin.$_$.ga;
  var VOID = kotlin_kotlin.$_$.g;
  var THROW_IAE = kotlin_kotlin.$_$.ld;
  var Unit_instance = kotlin_kotlin.$_$.t4;
  var Enum = kotlin_kotlin.$_$.zc;
  var defineProp = kotlin_kotlin.$_$.b9;
  var S2State = kotlin_io_komune_s2_s2_automate_dsl.$_$.j;
  var classMeta = kotlin_kotlin.$_$.z8;
  var S2TransitionBuilder = kotlin_io_komune_s2_s2_automate_dsl.$_$.b;
  var toValue = kotlin_io_komune_s2_s2_automate_dsl.$_$.m;
  var toValue_0 = kotlin_io_komune_s2_s2_automate_dsl.$_$.n;
  var getKClass = kotlin_kotlin.$_$.f;
  var toValue_1 = kotlin_io_komune_s2_s2_automate_dsl.$_$.l;
  var S2Transition = kotlin_io_komune_s2_s2_automate_dsl.$_$.k;
  var S2SelfTransitionBuilder = kotlin_io_komune_s2_s2_automate_dsl.$_$.a;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.j5;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.k;
  var s2Sourcing = kotlin_io_komune_s2_s2_automate_dsl.$_$.c;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z1;
  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r;
  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e;
  var THROW_CCE = kotlin_kotlin.$_$.kd;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u1;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v1;
  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e2;
  var objectCreate = kotlin_kotlin.$_$.da;
  var S2Role = kotlin_io_komune_s2_s2_automate_dsl.$_$.i;
  var S2InitCommand = kotlin_io_komune_s2_s2_automate_dsl.$_$.h;
  var interfaceMeta = kotlin_kotlin.$_$.k9;
  var WithS2Id = kotlin_io_komune_s2_s2_automate_dsl.$_$.e;
  var Event = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.d;
  var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v;
  var getStringHashCode = kotlin_kotlin.$_$.i9;
  var $serializer_getInstance = kotlin_org_boislocal_commons_domain.$_$.g;
  var LongSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q;
  var toString = kotlin_kotlin.$_$.le;
  var equals = kotlin_kotlin.$_$.c9;
  var S2Command = kotlin_io_komune_s2_s2_automate_dsl.$_$.g;
  var Long = kotlin_kotlin.$_$.ed;
  var WithS2State = kotlin_io_komune_s2_s2_automate_dsl.$_$.f;
  var Roles_instance = kotlin_org_boislocal_commons_domain.$_$.b;
  var hasRole = kotlin_org_boislocal_commons_domain.$_$.m;
  var ensureNotNull = kotlin_kotlin.$_$.be;
  var isAvailableTransition = kotlin_io_komune_s2_s2_automate_dsl.$_$.d;
  var Query = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.e;
  var PageQueryDTO = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.a;
  var PageQueryResultDTO = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.b;
  //endregion
  //region block: pre-declaration
  setMetadataFor(Companion, 'Companion', objectMeta, VOID, [SerializerFactory]);
  setMetadataFor(RemovalZoneCertificationState, 'RemovalZoneCertificationState', classMeta, Enum, [Enum, S2State], VOID, VOID, {0: Companion_getInstance});
  setMetadataFor(S2, 'S2', objectMeta);
  setMetadataFor(UserRole, 'UserRole', classMeta, VOID, [S2Role], VOID, VOID, {0: $serializer_getInstance_0});
  setMetadataFor(User, 'User', objectMeta, UserRole);
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor($serializer, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RemovalZoneCertificationCreateCommandDTO, 'RemovalZoneCertificationCreateCommandDTO', interfaceMeta, VOID, [S2InitCommand]);
  setMetadataFor(RemovalZoneCertificationCreatedEventDTO, 'RemovalZoneCertificationCreatedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_1, 'Companion', objectMeta);
  setMetadataFor($serializer_0, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RemovalZoneCertificationCreateCommand, 'RemovalZoneCertificationCreateCommand', classMeta, VOID, [RemovalZoneCertificationCreateCommandDTO], VOID, VOID, {0: $serializer_getInstance_1});
  setMetadataFor(Companion_2, 'Companion', objectMeta);
  setMetadataFor($serializer_1, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RemovalZoneCertificationCreatedEvent, 'RemovalZoneCertificationCreatedEvent', classMeta, VOID, [RemovalZoneCertificationCreatedEventDTO], VOID, VOID, {0: $serializer_getInstance_2});
  setMetadataFor(RemovalZoneCertificationDeleteCommandDTO, 'RemovalZoneCertificationDeleteCommandDTO', interfaceMeta, VOID, [S2Command]);
  setMetadataFor(RemovalZoneCertificationDeletedEventDTO, 'RemovalZoneCertificationDeletedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_3, 'Companion', objectMeta);
  setMetadataFor($serializer_2, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RemovalZoneCertificationDeleteCommand, 'RemovalZoneCertificationDeleteCommand', classMeta, VOID, [RemovalZoneCertificationDeleteCommandDTO], VOID, VOID, {0: $serializer_getInstance_3});
  setMetadataFor(Companion_4, 'Companion', objectMeta);
  setMetadataFor($serializer_3, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RemovalZoneCertificationDeletedEvent, 'RemovalZoneCertificationDeletedEvent', classMeta, VOID, [RemovalZoneCertificationDeletedEventDTO], VOID, VOID, {0: $serializer_getInstance_4});
  setMetadataFor(RemovalZoneCertificationImportCommandDTO, 'RemovalZoneCertificationImportCommandDTO', interfaceMeta, VOID, [S2InitCommand]);
  setMetadataFor(RemovalZoneCertificationImportedEventDTO, 'RemovalZoneCertificationImportedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_5, 'Companion', objectMeta);
  setMetadataFor($serializer_4, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RemovalZoneCertificationImportCommand, 'RemovalZoneCertificationImportCommand', classMeta, VOID, [RemovalZoneCertificationImportCommandDTO], VOID, VOID, {0: $serializer_getInstance_5});
  setMetadataFor(Companion_6, 'Companion', objectMeta);
  setMetadataFor($serializer_5, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RemovalZoneCertificationImportedEvent, 'RemovalZoneCertificationImportedEvent', classMeta, VOID, [RemovalZoneCertificationImportedEventDTO], VOID, VOID, {0: $serializer_getInstance_6});
  setMetadataFor(RemovalZoneCertificationUpdateCommandDTO, 'RemovalZoneCertificationUpdateCommandDTO', interfaceMeta, VOID, [S2Command]);
  setMetadataFor(RemovalZoneCertificationUpdatedEventDTO, 'RemovalZoneCertificationUpdatedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_7, 'Companion', objectMeta);
  setMetadataFor($serializer_6, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RemovalZoneCertificationUpdateCommand, 'RemovalZoneCertificationUpdateCommand', classMeta, VOID, [RemovalZoneCertificationUpdateCommandDTO], VOID, VOID, {0: $serializer_getInstance_7});
  setMetadataFor(Companion_8, 'Companion', objectMeta);
  setMetadataFor($serializer_7, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RemovalZoneCertificationUpdatedEvent, 'RemovalZoneCertificationUpdatedEvent', classMeta, VOID, [RemovalZoneCertificationUpdatedEventDTO], VOID, VOID, {0: $serializer_getInstance_8});
  setMetadataFor(RemovalZoneCertificationModelDTO, 'RemovalZoneCertificationModelDTO', interfaceMeta, VOID, [WithS2State, WithS2Id]);
  setMetadataFor(Companion_9, 'Companion', objectMeta);
  setMetadataFor($serializer_8, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RemovalZoneCertificationModel, 'RemovalZoneCertificationModel', classMeta, VOID, [RemovalZoneCertificationModelDTO], VOID, VOID, {0: $serializer_getInstance_9});
  setMetadataFor(RemovalZoneCertificationPolicies, 'RemovalZoneCertificationPolicies', objectMeta);
  setMetadataFor(RemovalZoneCertificationGetQueryDTO, 'RemovalZoneCertificationGetQueryDTO', interfaceMeta, VOID, [Query]);
  setMetadataFor(RemovalZoneCertificationGetResponseDTO, 'RemovalZoneCertificationGetResponseDTO', interfaceMeta);
  setMetadataFor(RemovalZoneCertificationPageQueryDTO, 'RemovalZoneCertificationPageQueryDTO', interfaceMeta, VOID, [PageQueryDTO]);
  setMetadataFor(RemovalZoneCertificationPageResponseDTO, 'RemovalZoneCertificationPageResponseDTO', interfaceMeta, VOID, [PageQueryResultDTO]);
  //endregion
  function _get_$cachedSerializer__te6jhj($this) {
    return $this.x2m_1.f2();
  }
  function RemovalZoneCertificationState$Companion$_anonymous__qjce68() {
    return createSimpleEnumSerializer('org.boislocal.platform.s2.removalZoneCertification.domain.automate.RemovalZoneCertificationState', values());
  }
  var RemovalZoneCertificationState_Exists_instance;
  var RemovalZoneCertificationState_Deleted_instance;
  function Companion() {
    Companion_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.x2m_1 = lazy(tmp_0, RemovalZoneCertificationState$Companion$_anonymous__qjce68);
  }
  protoOf(Companion).x14 = function () {
    return _get_$cachedSerializer__te6jhj(this);
  };
  protoOf(Companion).hu = function (typeParamsSerializers) {
    return this.x14();
  };
  var Companion_instance;
  function Companion_getInstance() {
    RemovalZoneCertificationState_initEntries();
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function values() {
    return [RemovalZoneCertificationState_Exists_getInstance(), RemovalZoneCertificationState_Deleted_getInstance()];
  }
  function valueOf(value) {
    switch (value) {
      case 'Exists':
        return RemovalZoneCertificationState_Exists_getInstance();
      case 'Deleted':
        return RemovalZoneCertificationState_Deleted_getInstance();
      default:
        RemovalZoneCertificationState_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var RemovalZoneCertificationState_entriesInitialized;
  function RemovalZoneCertificationState_initEntries() {
    if (RemovalZoneCertificationState_entriesInitialized)
      return Unit_instance;
    RemovalZoneCertificationState_entriesInitialized = true;
    RemovalZoneCertificationState_Exists_instance = new RemovalZoneCertificationState('Exists', 0, 0);
    RemovalZoneCertificationState_Deleted_instance = new RemovalZoneCertificationState('Deleted', 1, 1);
    Companion_getInstance();
  }
  function RemovalZoneCertificationState(name, ordinal, position) {
    Enum.call(this, name, ordinal);
    this.a2n_1 = position;
  }
  protoOf(RemovalZoneCertificationState).y2c = function (_set____db54di) {
    this.a2n_1 = _set____db54di;
  };
  protoOf(RemovalZoneCertificationState).jr = function () {
    return this.a2n_1;
  };
  function S2$removalZoneCertificationAutomate$lambda($this$s2Sourcing) {
    $this$s2Sourcing.j27_1 = 'RemovalZoneCertification';
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.transaction' call
    var builder = new S2TransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.removalZoneCertification.domain.automate.S2.removalZoneCertificationAutomate.<anonymous>.<anonymous>' call
    builder.o27_1 = RemovalZoneCertificationState_Exists_getInstance();
    builder.p27_1 = User_getInstance();
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver = builder.m27_1;
    var tmp = tmp0_safe_receiver == null ? null : toValue(tmp0_safe_receiver);
    var tmp_0 = toValue(builder.c24());
    var tmp_1 = toValue_0(builder.d24());
    var tmp_2 = toValue_1(getKClass(RemovalZoneCertificationImportCommand));
    var tmp1_elvis_lhs = builder.q27_1;
    var this_0 = new S2Transition(tmp, tmp_0, tmp_1, tmp_2, toValue_1(tmp1_elvis_lhs == null ? getKClass(RemovalZoneCertificationImportedEvent) : tmp1_elvis_lhs));
    // Inline function 'kotlin.contracts.contract' call
    $this$s2Sourcing.l27_1.r(this_0);
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.transaction' call
    var builder_0 = new S2TransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.removalZoneCertification.domain.automate.S2.removalZoneCertificationAutomate.<anonymous>.<anonymous>' call
    builder_0.o27_1 = RemovalZoneCertificationState_Deleted_getInstance();
    builder_0.p27_1 = User_getInstance();
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_0 = builder_0.m27_1;
    var tmp_3 = tmp0_safe_receiver_0 == null ? null : toValue(tmp0_safe_receiver_0);
    var tmp_4 = toValue(builder_0.c24());
    var tmp_5 = toValue_0(builder_0.d24());
    var tmp_6 = toValue_1(getKClass(RemovalZoneCertificationImportCommand));
    var tmp1_elvis_lhs_0 = builder_0.q27_1;
    var this_1 = new S2Transition(tmp_3, tmp_4, tmp_5, tmp_6, toValue_1(tmp1_elvis_lhs_0 == null ? getKClass(RemovalZoneCertificationImportedEvent) : tmp1_elvis_lhs_0));
    // Inline function 'kotlin.contracts.contract' call
    $this$s2Sourcing.l27_1.r(this_1);
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.transaction' call
    var builder_1 = new S2TransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.removalZoneCertification.domain.automate.S2.removalZoneCertificationAutomate.<anonymous>.<anonymous>' call
    builder_1.o27_1 = RemovalZoneCertificationState_Exists_getInstance();
    builder_1.p27_1 = User_getInstance();
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_1 = builder_1.m27_1;
    var tmp_7 = tmp0_safe_receiver_1 == null ? null : toValue(tmp0_safe_receiver_1);
    var tmp_8 = toValue(builder_1.c24());
    var tmp_9 = toValue_0(builder_1.d24());
    var tmp_10 = toValue_1(getKClass(RemovalZoneCertificationCreateCommand));
    var tmp1_elvis_lhs_1 = builder_1.q27_1;
    var this_2 = new S2Transition(tmp_7, tmp_8, tmp_9, tmp_10, toValue_1(tmp1_elvis_lhs_1 == null ? getKClass(RemovalZoneCertificationCreatedEvent) : tmp1_elvis_lhs_1));
    // Inline function 'kotlin.contracts.contract' call
    $this$s2Sourcing.l27_1.r(this_2);
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.selfTransaction' call
    var builder_2 = new S2SelfTransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.removalZoneCertification.domain.automate.S2.removalZoneCertificationAutomate.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.collections.plusAssign' call
    var this_3 = builder_2.r27_1;
    var element = RemovalZoneCertificationState_Exists_getInstance();
    this_3.r(element);
    builder_2.s27_1 = User_getInstance();
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.map' call
    var this_4 = builder_2.r27_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_4, 10));
    var tmp0_iterator = this_4.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.w();
      // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.selfTransaction.<anonymous>' call
      var tmp_11 = toValue(item);
      var tmp_12 = toValue(item);
      var tmp_13 = toValue_0(builder_2.d24());
      var tmp_14 = toValue_1(getKClass(RemovalZoneCertificationUpdateCommand));
      var tmp0_elvis_lhs = builder_2.t27_1;
      var tmp$ret$6 = new S2Transition(tmp_11, tmp_12, tmp_13, tmp_14, toValue_1(tmp0_elvis_lhs == null ? getKClass(RemovalZoneCertificationUpdatedEvent) : tmp0_elvis_lhs));
      destination.r(tmp$ret$6);
    }
    var tmp3_forEach_receiver = $this$s2Sourcing.l27_1;
    var tmp0_iterator_0 = destination.u();
    while (tmp0_iterator_0.v()) {
      var element_0 = tmp0_iterator_0.w();
      invoke$add(tmp3_forEach_receiver, element_0);
    }
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.transaction' call
    var builder_3 = new S2TransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.removalZoneCertification.domain.automate.S2.removalZoneCertificationAutomate.<anonymous>.<anonymous>' call
    builder_3.m27_1 = RemovalZoneCertificationState_Exists_getInstance();
    builder_3.o27_1 = RemovalZoneCertificationState_Deleted_getInstance();
    builder_3.p27_1 = User_getInstance();
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_2 = builder_3.m27_1;
    var tmp_15 = tmp0_safe_receiver_2 == null ? null : toValue(tmp0_safe_receiver_2);
    var tmp_16 = toValue(builder_3.c24());
    var tmp_17 = toValue_0(builder_3.d24());
    var tmp_18 = toValue_1(getKClass(RemovalZoneCertificationDeleteCommand));
    var tmp1_elvis_lhs_2 = builder_3.q27_1;
    var this_5 = new S2Transition(tmp_15, tmp_16, tmp_17, tmp_18, toValue_1(tmp1_elvis_lhs_2 == null ? getKClass(RemovalZoneCertificationDeletedEvent) : tmp1_elvis_lhs_2));
    // Inline function 'kotlin.contracts.contract' call
    $this$s2Sourcing.l27_1.r(this_5);
    return Unit_instance;
  }
  function invoke$add(receiver, p0) {
    receiver.r(p0);
  }
  function S2() {
    S2_instance = this;
    var tmp = this;
    tmp.b2n_1 = s2Sourcing(S2$removalZoneCertificationAutomate$lambda);
  }
  var S2_instance;
  function S2_getInstance() {
    if (S2_instance == null)
      new S2();
    return S2_instance;
  }
  function User() {
    User_instance = this;
    UserRole.call(this, 'User');
  }
  var User_instance;
  function User_getInstance() {
    if (User_instance == null)
      new User();
    return User_instance;
  }
  function Companion_0() {
  }
  var Companion_instance_0;
  function Companion_getInstance_0() {
    return Companion_instance_0;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.removalZoneCertification.domain.automate.UserRole', this, 1);
    tmp0_serialDesc.ht('name', false);
    this.d2n_1 = tmp0_serialDesc;
  }
  protoOf($serializer).ii = function () {
    return this.d2n_1;
  };
  protoOf($serializer).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  protoOf($serializer).ki = function (decoder) {
    var tmp0_desc = this.d2n_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.ul(tmp0_desc);
    if (tmp5_input.km()) {
      tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.vl(tmp0_desc);
    return UserRole_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer).e2n = function (encoder, value) {
    var tmp0_desc = this.d2n_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.h9());
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer).ji = function (encoder, value) {
    return this.e2n(encoder, value instanceof UserRole ? value : THROW_CCE());
  };
  var $serializer_instance;
  function $serializer_getInstance_0() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function UserRole_init_$Init$(seen1, name, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_0().d2n_1);
    }
    $this.c2n_1 = name;
    return $this;
  }
  function UserRole_init_$Create$(seen1, name, serializationConstructorMarker) {
    return UserRole_init_$Init$(seen1, name, serializationConstructorMarker, objectCreate(protoOf(UserRole)));
  }
  function UserRole(name) {
    this.c2n_1 = name;
  }
  protoOf(UserRole).h9 = function () {
    return this.c2n_1;
  };
  protoOf(UserRole).toString = function () {
    return this.h9();
  };
  function RemovalZoneCertificationState_Exists_getInstance() {
    RemovalZoneCertificationState_initEntries();
    return RemovalZoneCertificationState_Exists_instance;
  }
  function RemovalZoneCertificationState_Deleted_getInstance() {
    RemovalZoneCertificationState_initEntries();
    return RemovalZoneCertificationState_Deleted_instance;
  }
  function RemovalZoneCertificationCreateCommandDTO() {
  }
  function RemovalZoneCertificationCreatedEventDTO() {
  }
  function Companion_1() {
  }
  var Companion_instance_1;
  function Companion_getInstance_1() {
    return Companion_instance_1;
  }
  function $serializer_0() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.removalZoneCertification.domain.command.RemovalZoneCertificationCreateCommand', this, 2);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('img', false);
    this.f2n_1 = tmp0_serialDesc;
  }
  protoOf($serializer_0).ii = function () {
    return this.f2n_1;
  };
  protoOf($serializer_0).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  protoOf($serializer_0).ki = function (decoder) {
    var tmp0_desc = this.f2n_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.ul(tmp0_desc);
    if (tmp6_input.km()) {
      tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.im(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.im(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.vl(tmp0_desc);
    return RemovalZoneCertificationCreateCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_0).g2n = function (encoder, value) {
    var tmp0_desc = this.f2n_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.h2n_1);
    tmp1_output.nn(tmp0_desc, 1, StringSerializer_getInstance(), value.i2n_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_0).ji = function (encoder, value) {
    return this.g2n(encoder, value instanceof RemovalZoneCertificationCreateCommand ? value : THROW_CCE());
  };
  var $serializer_instance_0;
  function $serializer_getInstance_1() {
    if ($serializer_instance_0 == null)
      new $serializer_0();
    return $serializer_instance_0;
  }
  function RemovalZoneCertificationCreateCommand_init_$Init$(seen1, name, img, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_1().f2n_1);
    }
    $this.h2n_1 = name;
    $this.i2n_1 = img;
    return $this;
  }
  function RemovalZoneCertificationCreateCommand_init_$Create$(seen1, name, img, serializationConstructorMarker) {
    return RemovalZoneCertificationCreateCommand_init_$Init$(seen1, name, img, serializationConstructorMarker, objectCreate(protoOf(RemovalZoneCertificationCreateCommand)));
  }
  function RemovalZoneCertificationCreateCommand(name, img) {
    this.h2n_1 = name;
    this.i2n_1 = img;
  }
  protoOf(RemovalZoneCertificationCreateCommand).h9 = function () {
    return this.h2n_1;
  };
  protoOf(RemovalZoneCertificationCreateCommand).d2d = function () {
    return this.i2n_1;
  };
  protoOf(RemovalZoneCertificationCreateCommand).toString = function () {
    return 'RemovalZoneCertificationCreateCommand(name=' + this.h2n_1 + ', img=' + this.i2n_1 + ')';
  };
  protoOf(RemovalZoneCertificationCreateCommand).hashCode = function () {
    var result = getStringHashCode(this.h2n_1);
    result = imul(result, 31) + (this.i2n_1 == null ? 0 : getStringHashCode(this.i2n_1)) | 0;
    return result;
  };
  protoOf(RemovalZoneCertificationCreateCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RemovalZoneCertificationCreateCommand))
      return false;
    var tmp0_other_with_cast = other instanceof RemovalZoneCertificationCreateCommand ? other : THROW_CCE();
    if (!(this.h2n_1 === tmp0_other_with_cast.h2n_1))
      return false;
    if (!(this.i2n_1 == tmp0_other_with_cast.i2n_1))
      return false;
    return true;
  };
  function Companion_2() {
  }
  var Companion_instance_2;
  function Companion_getInstance_2() {
    return Companion_instance_2;
  }
  function $serializer_1() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RemovalZoneCertificationCreatedEvent', this, 4);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('img', false);
    tmp0_serialDesc.ht('time', false);
    this.j2n_1 = tmp0_serialDesc;
  }
  protoOf($serializer_1).ii = function () {
    return this.j2n_1;
  };
  protoOf($serializer_1).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable($serializer_getInstance()), get_nullable(LongSerializer_getInstance())];
  };
  protoOf($serializer_1).ki = function (decoder) {
    var tmp0_desc = this.j2n_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.ul(tmp0_desc);
    if (tmp8_input.km()) {
      tmp4_local0 = tmp8_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.em(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.im(tmp0_desc, 2, $serializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.im(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.em(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.im(tmp0_desc, 2, $serializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.im(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.vl(tmp0_desc);
    return RemovalZoneCertificationCreatedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_1).k2n = function (encoder, value) {
    var tmp0_desc = this.j2n_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.l2n_1);
    tmp1_output.jn(tmp0_desc, 1, value.m2n_1);
    tmp1_output.nn(tmp0_desc, 2, $serializer_getInstance(), value.n2n_1);
    tmp1_output.nn(tmp0_desc, 3, LongSerializer_getInstance(), value.o2n_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_1).ji = function (encoder, value) {
    return this.k2n(encoder, value instanceof RemovalZoneCertificationCreatedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_1;
  function $serializer_getInstance_2() {
    if ($serializer_instance_1 == null)
      new $serializer_1();
    return $serializer_instance_1;
  }
  function RemovalZoneCertificationCreatedEvent_init_$Init$(seen1, id, name, img, time, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen1))) {
      throwMissingFieldException(seen1, 15, $serializer_getInstance_2().j2n_1);
    }
    $this.l2n_1 = id;
    $this.m2n_1 = name;
    $this.n2n_1 = img;
    $this.o2n_1 = time;
    return $this;
  }
  function RemovalZoneCertificationCreatedEvent_init_$Create$(seen1, id, name, img, time, serializationConstructorMarker) {
    return RemovalZoneCertificationCreatedEvent_init_$Init$(seen1, id, name, img, time, serializationConstructorMarker, objectCreate(protoOf(RemovalZoneCertificationCreatedEvent)));
  }
  function RemovalZoneCertificationCreatedEvent(id, name, img, time) {
    this.l2n_1 = id;
    this.m2n_1 = name;
    this.n2n_1 = img;
    this.o2n_1 = time;
  }
  protoOf(RemovalZoneCertificationCreatedEvent).k1y = function () {
    return this.l2n_1;
  };
  protoOf(RemovalZoneCertificationCreatedEvent).h9 = function () {
    return this.m2n_1;
  };
  protoOf(RemovalZoneCertificationCreatedEvent).d2d = function () {
    return this.n2n_1;
  };
  protoOf(RemovalZoneCertificationCreatedEvent).g2c = function () {
    return this.o2n_1;
  };
  protoOf(RemovalZoneCertificationCreatedEvent).s2Id = function () {
    return this.l2n_1;
  };
  protoOf(RemovalZoneCertificationCreatedEvent).toString = function () {
    return 'RemovalZoneCertificationCreatedEvent(id=' + this.l2n_1 + ', name=' + this.m2n_1 + ', img=' + this.n2n_1 + ', time=' + toString(this.o2n_1) + ')';
  };
  protoOf(RemovalZoneCertificationCreatedEvent).hashCode = function () {
    var result = getStringHashCode(this.l2n_1);
    result = imul(result, 31) + getStringHashCode(this.m2n_1) | 0;
    result = imul(result, 31) + (this.n2n_1 == null ? 0 : this.n2n_1.hashCode()) | 0;
    result = imul(result, 31) + (this.o2n_1 == null ? 0 : this.o2n_1.hashCode()) | 0;
    return result;
  };
  protoOf(RemovalZoneCertificationCreatedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RemovalZoneCertificationCreatedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof RemovalZoneCertificationCreatedEvent ? other : THROW_CCE();
    if (!(this.l2n_1 === tmp0_other_with_cast.l2n_1))
      return false;
    if (!(this.m2n_1 === tmp0_other_with_cast.m2n_1))
      return false;
    if (!equals(this.n2n_1, tmp0_other_with_cast.n2n_1))
      return false;
    if (!equals(this.o2n_1, tmp0_other_with_cast.o2n_1))
      return false;
    return true;
  };
  function RemovalZoneCertificationDeleteCommandDTO() {
  }
  function RemovalZoneCertificationDeletedEventDTO() {
  }
  function Companion_3() {
  }
  var Companion_instance_3;
  function Companion_getInstance_3() {
    return Companion_instance_3;
  }
  function $serializer_2() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.removalZoneCertification.domain.command.RemovalZoneCertificationDeleteCommand', this, 1);
    tmp0_serialDesc.ht('id', false);
    this.p2n_1 = tmp0_serialDesc;
  }
  protoOf($serializer_2).ii = function () {
    return this.p2n_1;
  };
  protoOf($serializer_2).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  protoOf($serializer_2).ki = function (decoder) {
    var tmp0_desc = this.p2n_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.ul(tmp0_desc);
    if (tmp5_input.km()) {
      tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.vl(tmp0_desc);
    return RemovalZoneCertificationDeleteCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_2).q2n = function (encoder, value) {
    var tmp0_desc = this.p2n_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.r2n_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_2).ji = function (encoder, value) {
    return this.q2n(encoder, value instanceof RemovalZoneCertificationDeleteCommand ? value : THROW_CCE());
  };
  var $serializer_instance_2;
  function $serializer_getInstance_3() {
    if ($serializer_instance_2 == null)
      new $serializer_2();
    return $serializer_instance_2;
  }
  function RemovalZoneCertificationDeleteCommand_init_$Init$(seen1, id, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_3().p2n_1);
    }
    $this.r2n_1 = id;
    return $this;
  }
  function RemovalZoneCertificationDeleteCommand_init_$Create$(seen1, id, serializationConstructorMarker) {
    return RemovalZoneCertificationDeleteCommand_init_$Init$(seen1, id, serializationConstructorMarker, objectCreate(protoOf(RemovalZoneCertificationDeleteCommand)));
  }
  function RemovalZoneCertificationDeleteCommand(id) {
    this.r2n_1 = id;
  }
  protoOf(RemovalZoneCertificationDeleteCommand).k1y = function () {
    return this.r2n_1;
  };
  protoOf(RemovalZoneCertificationDeleteCommand).toString = function () {
    return 'RemovalZoneCertificationDeleteCommand(id=' + this.r2n_1 + ')';
  };
  protoOf(RemovalZoneCertificationDeleteCommand).hashCode = function () {
    return getStringHashCode(this.r2n_1);
  };
  protoOf(RemovalZoneCertificationDeleteCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RemovalZoneCertificationDeleteCommand))
      return false;
    var tmp0_other_with_cast = other instanceof RemovalZoneCertificationDeleteCommand ? other : THROW_CCE();
    if (!(this.r2n_1 === tmp0_other_with_cast.r2n_1))
      return false;
    return true;
  };
  function Companion_4() {
  }
  var Companion_instance_4;
  function Companion_getInstance_4() {
    return Companion_instance_4;
  }
  function $serializer_3() {
    $serializer_instance_3 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RemovalZoneCertificationDeletedEvent', this, 2);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('time', false);
    this.s2n_1 = tmp0_serialDesc;
  }
  protoOf($serializer_3).ii = function () {
    return this.s2n_1;
  };
  protoOf($serializer_3).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance())];
  };
  protoOf($serializer_3).ki = function (decoder) {
    var tmp0_desc = this.s2n_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.ul(tmp0_desc);
    if (tmp6_input.km()) {
      tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.im(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.im(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.vl(tmp0_desc);
    return RemovalZoneCertificationDeletedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_3).t2n = function (encoder, value) {
    var tmp0_desc = this.s2n_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.u2n_1);
    tmp1_output.nn(tmp0_desc, 1, LongSerializer_getInstance(), value.v2n_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_3).ji = function (encoder, value) {
    return this.t2n(encoder, value instanceof RemovalZoneCertificationDeletedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_3;
  function $serializer_getInstance_4() {
    if ($serializer_instance_3 == null)
      new $serializer_3();
    return $serializer_instance_3;
  }
  function RemovalZoneCertificationDeletedEvent_init_$Init$(seen1, id, time, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_4().s2n_1);
    }
    $this.u2n_1 = id;
    $this.v2n_1 = time;
    return $this;
  }
  function RemovalZoneCertificationDeletedEvent_init_$Create$(seen1, id, time, serializationConstructorMarker) {
    return RemovalZoneCertificationDeletedEvent_init_$Init$(seen1, id, time, serializationConstructorMarker, objectCreate(protoOf(RemovalZoneCertificationDeletedEvent)));
  }
  function RemovalZoneCertificationDeletedEvent(id, time) {
    this.u2n_1 = id;
    this.v2n_1 = time;
  }
  protoOf(RemovalZoneCertificationDeletedEvent).k1y = function () {
    return this.u2n_1;
  };
  protoOf(RemovalZoneCertificationDeletedEvent).g2c = function () {
    return this.v2n_1;
  };
  protoOf(RemovalZoneCertificationDeletedEvent).s2Id = function () {
    return this.u2n_1;
  };
  protoOf(RemovalZoneCertificationDeletedEvent).toString = function () {
    return 'RemovalZoneCertificationDeletedEvent(id=' + this.u2n_1 + ', time=' + toString(this.v2n_1) + ')';
  };
  protoOf(RemovalZoneCertificationDeletedEvent).hashCode = function () {
    var result = getStringHashCode(this.u2n_1);
    result = imul(result, 31) + (this.v2n_1 == null ? 0 : this.v2n_1.hashCode()) | 0;
    return result;
  };
  protoOf(RemovalZoneCertificationDeletedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RemovalZoneCertificationDeletedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof RemovalZoneCertificationDeletedEvent ? other : THROW_CCE();
    if (!(this.u2n_1 === tmp0_other_with_cast.u2n_1))
      return false;
    if (!equals(this.v2n_1, tmp0_other_with_cast.v2n_1))
      return false;
    return true;
  };
  function RemovalZoneCertificationImportCommandDTO() {
  }
  function RemovalZoneCertificationImportedEventDTO() {
  }
  function Companion_5() {
  }
  var Companion_instance_5;
  function Companion_getInstance_5() {
    return Companion_instance_5;
  }
  function $serializer_4() {
    $serializer_instance_4 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.removalZoneCertification.domain.command.RemovalZoneCertificationImportCommand', this, 1);
    tmp0_serialDesc.ht('item', false);
    this.w2n_1 = tmp0_serialDesc;
  }
  protoOf($serializer_4).ii = function () {
    return this.w2n_1;
  };
  protoOf($serializer_4).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_9()];
  };
  protoOf($serializer_4).ki = function (decoder) {
    var tmp0_desc = this.w2n_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.ul(tmp0_desc);
    if (tmp5_input.km()) {
      tmp4_local0 = tmp5_input.gm(tmp0_desc, 0, $serializer_getInstance_9(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.gm(tmp0_desc, 0, $serializer_getInstance_9(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.vl(tmp0_desc);
    return RemovalZoneCertificationImportCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_4).x2n = function (encoder, value) {
    var tmp0_desc = this.w2n_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.ln(tmp0_desc, 0, $serializer_getInstance_9(), value.y2n_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_4).ji = function (encoder, value) {
    return this.x2n(encoder, value instanceof RemovalZoneCertificationImportCommand ? value : THROW_CCE());
  };
  var $serializer_instance_4;
  function $serializer_getInstance_5() {
    if ($serializer_instance_4 == null)
      new $serializer_4();
    return $serializer_instance_4;
  }
  function RemovalZoneCertificationImportCommand_init_$Init$(seen1, item, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_5().w2n_1);
    }
    $this.y2n_1 = item;
    return $this;
  }
  function RemovalZoneCertificationImportCommand_init_$Create$(seen1, item, serializationConstructorMarker) {
    return RemovalZoneCertificationImportCommand_init_$Init$(seen1, item, serializationConstructorMarker, objectCreate(protoOf(RemovalZoneCertificationImportCommand)));
  }
  function RemovalZoneCertificationImportCommand(item) {
    this.y2n_1 = item;
  }
  protoOf(RemovalZoneCertificationImportCommand).q20 = function () {
    return this.y2n_1;
  };
  protoOf(RemovalZoneCertificationImportCommand).toString = function () {
    return 'RemovalZoneCertificationImportCommand(item=' + this.y2n_1 + ')';
  };
  protoOf(RemovalZoneCertificationImportCommand).hashCode = function () {
    return this.y2n_1.hashCode();
  };
  protoOf(RemovalZoneCertificationImportCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RemovalZoneCertificationImportCommand))
      return false;
    var tmp0_other_with_cast = other instanceof RemovalZoneCertificationImportCommand ? other : THROW_CCE();
    if (!this.y2n_1.equals(tmp0_other_with_cast.y2n_1))
      return false;
    return true;
  };
  function Companion_6() {
  }
  var Companion_instance_6;
  function Companion_getInstance_6() {
    return Companion_instance_6;
  }
  function $serializer_5() {
    $serializer_instance_5 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RemovalZoneCertificationImportedEvent', this, 2);
    tmp0_serialDesc.ht('item', false);
    tmp0_serialDesc.ht('time', false);
    this.z2n_1 = tmp0_serialDesc;
  }
  protoOf($serializer_5).ii = function () {
    return this.z2n_1;
  };
  protoOf($serializer_5).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_9(), LongSerializer_getInstance()];
  };
  protoOf($serializer_5).ki = function (decoder) {
    var tmp0_desc = this.z2n_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = new Long(0, 0);
    var tmp6_input = decoder.ul(tmp0_desc);
    if (tmp6_input.km()) {
      tmp4_local0 = tmp6_input.gm(tmp0_desc, 0, $serializer_getInstance_9(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.am(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.gm(tmp0_desc, 0, $serializer_getInstance_9(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.am(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.vl(tmp0_desc);
    return RemovalZoneCertificationImportedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_5).a2o = function (encoder, value) {
    var tmp0_desc = this.z2n_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.ln(tmp0_desc, 0, $serializer_getInstance_9(), value.b2o_1);
    tmp1_output.fn(tmp0_desc, 1, value.c2o_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_5).ji = function (encoder, value) {
    return this.a2o(encoder, value instanceof RemovalZoneCertificationImportedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_5;
  function $serializer_getInstance_6() {
    if ($serializer_instance_5 == null)
      new $serializer_5();
    return $serializer_instance_5;
  }
  function RemovalZoneCertificationImportedEvent_init_$Init$(seen1, item, time, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_6().z2n_1);
    }
    $this.b2o_1 = item;
    $this.c2o_1 = time;
    return $this;
  }
  function RemovalZoneCertificationImportedEvent_init_$Create$(seen1, item, time, serializationConstructorMarker) {
    return RemovalZoneCertificationImportedEvent_init_$Init$(seen1, item, time, serializationConstructorMarker, objectCreate(protoOf(RemovalZoneCertificationImportedEvent)));
  }
  function RemovalZoneCertificationImportedEvent(item, time) {
    this.b2o_1 = item;
    this.c2o_1 = time;
  }
  protoOf(RemovalZoneCertificationImportedEvent).q20 = function () {
    return this.b2o_1;
  };
  protoOf(RemovalZoneCertificationImportedEvent).g2c = function () {
    return this.c2o_1;
  };
  protoOf(RemovalZoneCertificationImportedEvent).s2Id = function () {
    return this.b2o_1.d2o_1;
  };
  protoOf(RemovalZoneCertificationImportedEvent).toString = function () {
    return 'RemovalZoneCertificationImportedEvent(item=' + this.b2o_1 + ', time=' + this.c2o_1.toString() + ')';
  };
  protoOf(RemovalZoneCertificationImportedEvent).hashCode = function () {
    var result = this.b2o_1.hashCode();
    result = imul(result, 31) + this.c2o_1.hashCode() | 0;
    return result;
  };
  protoOf(RemovalZoneCertificationImportedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RemovalZoneCertificationImportedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof RemovalZoneCertificationImportedEvent ? other : THROW_CCE();
    if (!this.b2o_1.equals(tmp0_other_with_cast.b2o_1))
      return false;
    if (!this.c2o_1.equals(tmp0_other_with_cast.c2o_1))
      return false;
    return true;
  };
  function RemovalZoneCertificationUpdateCommandDTO() {
  }
  function RemovalZoneCertificationUpdatedEventDTO() {
  }
  function Companion_7() {
  }
  var Companion_instance_7;
  function Companion_getInstance_7() {
    return Companion_instance_7;
  }
  function $serializer_6() {
    $serializer_instance_6 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.removalZoneCertification.domain.command.RemovalZoneCertificationUpdateCommand', this, 3);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('img', false);
    this.j2o_1 = tmp0_serialDesc;
  }
  protoOf($serializer_6).ii = function () {
    return this.j2o_1;
  };
  protoOf($serializer_6).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  protoOf($serializer_6).ki = function (decoder) {
    var tmp0_desc = this.j2o_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.ul(tmp0_desc);
    if (tmp7_input.km()) {
      tmp4_local0 = tmp7_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.em(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.im(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.em(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.im(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.vl(tmp0_desc);
    return RemovalZoneCertificationUpdateCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_6).k2o = function (encoder, value) {
    var tmp0_desc = this.j2o_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.l2o_1);
    tmp1_output.jn(tmp0_desc, 1, value.m2o_1);
    tmp1_output.nn(tmp0_desc, 2, StringSerializer_getInstance(), value.n2o_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_6).ji = function (encoder, value) {
    return this.k2o(encoder, value instanceof RemovalZoneCertificationUpdateCommand ? value : THROW_CCE());
  };
  var $serializer_instance_6;
  function $serializer_getInstance_7() {
    if ($serializer_instance_6 == null)
      new $serializer_6();
    return $serializer_instance_6;
  }
  function RemovalZoneCertificationUpdateCommand_init_$Init$(seen1, id, name, img, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen1))) {
      throwMissingFieldException(seen1, 7, $serializer_getInstance_7().j2o_1);
    }
    $this.l2o_1 = id;
    $this.m2o_1 = name;
    $this.n2o_1 = img;
    return $this;
  }
  function RemovalZoneCertificationUpdateCommand_init_$Create$(seen1, id, name, img, serializationConstructorMarker) {
    return RemovalZoneCertificationUpdateCommand_init_$Init$(seen1, id, name, img, serializationConstructorMarker, objectCreate(protoOf(RemovalZoneCertificationUpdateCommand)));
  }
  function RemovalZoneCertificationUpdateCommand(id, name, img) {
    this.l2o_1 = id;
    this.m2o_1 = name;
    this.n2o_1 = img;
  }
  protoOf(RemovalZoneCertificationUpdateCommand).k1y = function () {
    return this.l2o_1;
  };
  protoOf(RemovalZoneCertificationUpdateCommand).h9 = function () {
    return this.m2o_1;
  };
  protoOf(RemovalZoneCertificationUpdateCommand).d2d = function () {
    return this.n2o_1;
  };
  protoOf(RemovalZoneCertificationUpdateCommand).toString = function () {
    return 'RemovalZoneCertificationUpdateCommand(id=' + this.l2o_1 + ', name=' + this.m2o_1 + ', img=' + this.n2o_1 + ')';
  };
  protoOf(RemovalZoneCertificationUpdateCommand).hashCode = function () {
    var result = getStringHashCode(this.l2o_1);
    result = imul(result, 31) + getStringHashCode(this.m2o_1) | 0;
    result = imul(result, 31) + (this.n2o_1 == null ? 0 : getStringHashCode(this.n2o_1)) | 0;
    return result;
  };
  protoOf(RemovalZoneCertificationUpdateCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RemovalZoneCertificationUpdateCommand))
      return false;
    var tmp0_other_with_cast = other instanceof RemovalZoneCertificationUpdateCommand ? other : THROW_CCE();
    if (!(this.l2o_1 === tmp0_other_with_cast.l2o_1))
      return false;
    if (!(this.m2o_1 === tmp0_other_with_cast.m2o_1))
      return false;
    if (!(this.n2o_1 == tmp0_other_with_cast.n2o_1))
      return false;
    return true;
  };
  function Companion_8() {
  }
  var Companion_instance_8;
  function Companion_getInstance_8() {
    return Companion_instance_8;
  }
  function $serializer_7() {
    $serializer_instance_7 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RemovalZoneCertificationUpdatedEvent', this, 4);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('img', false);
    tmp0_serialDesc.ht('time', false);
    this.o2o_1 = tmp0_serialDesc;
  }
  protoOf($serializer_7).ii = function () {
    return this.o2o_1;
  };
  protoOf($serializer_7).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable($serializer_getInstance()), get_nullable(LongSerializer_getInstance())];
  };
  protoOf($serializer_7).ki = function (decoder) {
    var tmp0_desc = this.o2o_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.ul(tmp0_desc);
    if (tmp8_input.km()) {
      tmp4_local0 = tmp8_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.em(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.im(tmp0_desc, 2, $serializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.im(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.em(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.im(tmp0_desc, 2, $serializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.im(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.vl(tmp0_desc);
    return RemovalZoneCertificationUpdatedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_7).p2o = function (encoder, value) {
    var tmp0_desc = this.o2o_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.q2o_1);
    tmp1_output.jn(tmp0_desc, 1, value.r2o_1);
    tmp1_output.nn(tmp0_desc, 2, $serializer_getInstance(), value.s2o_1);
    tmp1_output.nn(tmp0_desc, 3, LongSerializer_getInstance(), value.t2o_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_7).ji = function (encoder, value) {
    return this.p2o(encoder, value instanceof RemovalZoneCertificationUpdatedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_7;
  function $serializer_getInstance_8() {
    if ($serializer_instance_7 == null)
      new $serializer_7();
    return $serializer_instance_7;
  }
  function RemovalZoneCertificationUpdatedEvent_init_$Init$(seen1, id, name, img, time, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen1))) {
      throwMissingFieldException(seen1, 15, $serializer_getInstance_8().o2o_1);
    }
    $this.q2o_1 = id;
    $this.r2o_1 = name;
    $this.s2o_1 = img;
    $this.t2o_1 = time;
    return $this;
  }
  function RemovalZoneCertificationUpdatedEvent_init_$Create$(seen1, id, name, img, time, serializationConstructorMarker) {
    return RemovalZoneCertificationUpdatedEvent_init_$Init$(seen1, id, name, img, time, serializationConstructorMarker, objectCreate(protoOf(RemovalZoneCertificationUpdatedEvent)));
  }
  function RemovalZoneCertificationUpdatedEvent(id, name, img, time) {
    this.q2o_1 = id;
    this.r2o_1 = name;
    this.s2o_1 = img;
    this.t2o_1 = time;
  }
  protoOf(RemovalZoneCertificationUpdatedEvent).k1y = function () {
    return this.q2o_1;
  };
  protoOf(RemovalZoneCertificationUpdatedEvent).h9 = function () {
    return this.r2o_1;
  };
  protoOf(RemovalZoneCertificationUpdatedEvent).d2d = function () {
    return this.s2o_1;
  };
  protoOf(RemovalZoneCertificationUpdatedEvent).g2c = function () {
    return this.t2o_1;
  };
  protoOf(RemovalZoneCertificationUpdatedEvent).s2Id = function () {
    return this.q2o_1;
  };
  protoOf(RemovalZoneCertificationUpdatedEvent).toString = function () {
    return 'RemovalZoneCertificationUpdatedEvent(id=' + this.q2o_1 + ', name=' + this.r2o_1 + ', img=' + this.s2o_1 + ', time=' + toString(this.t2o_1) + ')';
  };
  protoOf(RemovalZoneCertificationUpdatedEvent).hashCode = function () {
    var result = getStringHashCode(this.q2o_1);
    result = imul(result, 31) + getStringHashCode(this.r2o_1) | 0;
    result = imul(result, 31) + (this.s2o_1 == null ? 0 : this.s2o_1.hashCode()) | 0;
    result = imul(result, 31) + (this.t2o_1 == null ? 0 : this.t2o_1.hashCode()) | 0;
    return result;
  };
  protoOf(RemovalZoneCertificationUpdatedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RemovalZoneCertificationUpdatedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof RemovalZoneCertificationUpdatedEvent ? other : THROW_CCE();
    if (!(this.q2o_1 === tmp0_other_with_cast.q2o_1))
      return false;
    if (!(this.r2o_1 === tmp0_other_with_cast.r2o_1))
      return false;
    if (!equals(this.s2o_1, tmp0_other_with_cast.s2o_1))
      return false;
    if (!equals(this.t2o_1, tmp0_other_with_cast.t2o_1))
      return false;
    return true;
  };
  function RemovalZoneCertificationModelDTO() {
  }
  function Companion_9() {
    Companion_instance_9 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.u2o_1 = [null, Companion_getInstance().x14(), null, null, null, null];
  }
  var Companion_instance_9;
  function Companion_getInstance_9() {
    if (Companion_instance_9 == null)
      new Companion_9();
    return Companion_instance_9;
  }
  function $serializer_8() {
    $serializer_instance_8 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.removalZoneCertification.domain.model.RemovalZoneCertificationModel', this, 6);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('status', false);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('img', false);
    tmp0_serialDesc.ht('creationDate', false);
    tmp0_serialDesc.ht('updatedDate', false);
    this.v2o_1 = tmp0_serialDesc;
  }
  protoOf($serializer_8).ii = function () {
    return this.v2o_1;
  };
  protoOf($serializer_8).wt = function () {
    var tmp0_cached = Companion_getInstance_9().u2o_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), tmp0_cached[1], StringSerializer_getInstance(), get_nullable($serializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance())];
  };
  protoOf($serializer_8).ki = function (decoder) {
    var tmp0_desc = this.v2o_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_input = decoder.ul(tmp0_desc);
    var tmp11_cached = Companion_getInstance_9().u2o_1;
    if (tmp10_input.km()) {
      tmp4_local0 = tmp10_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.gm(tmp0_desc, 1, tmp11_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.em(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.im(tmp0_desc, 3, $serializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.im(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.im(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.gm(tmp0_desc, 1, tmp11_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.em(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.im(tmp0_desc, 3, $serializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.im(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.im(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.vl(tmp0_desc);
    return RemovalZoneCertificationModel_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  protoOf($serializer_8).w2o = function (encoder, value) {
    var tmp0_desc = this.v2o_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_9().u2o_1;
    tmp1_output.jn(tmp0_desc, 0, value.d2o_1);
    tmp1_output.ln(tmp0_desc, 1, tmp2_cached[1], value.e2o_1);
    tmp1_output.jn(tmp0_desc, 2, value.f2o_1);
    tmp1_output.nn(tmp0_desc, 3, $serializer_getInstance(), value.g2o_1);
    tmp1_output.nn(tmp0_desc, 4, LongSerializer_getInstance(), value.h2o_1);
    tmp1_output.nn(tmp0_desc, 5, LongSerializer_getInstance(), value.i2o_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_8).ji = function (encoder, value) {
    return this.w2o(encoder, value instanceof RemovalZoneCertificationModel ? value : THROW_CCE());
  };
  var $serializer_instance_8;
  function $serializer_getInstance_9() {
    if ($serializer_instance_8 == null)
      new $serializer_8();
    return $serializer_instance_8;
  }
  function RemovalZoneCertificationModel_init_$Init$(seen1, id, status, name, img, creationDate, updatedDate, serializationConstructorMarker, $this) {
    if (!(63 === (63 & seen1))) {
      throwMissingFieldException(seen1, 63, $serializer_getInstance_9().v2o_1);
    }
    $this.d2o_1 = id;
    $this.e2o_1 = status;
    $this.f2o_1 = name;
    $this.g2o_1 = img;
    $this.h2o_1 = creationDate;
    $this.i2o_1 = updatedDate;
    return $this;
  }
  function RemovalZoneCertificationModel_init_$Create$(seen1, id, status, name, img, creationDate, updatedDate, serializationConstructorMarker) {
    return RemovalZoneCertificationModel_init_$Init$(seen1, id, status, name, img, creationDate, updatedDate, serializationConstructorMarker, objectCreate(protoOf(RemovalZoneCertificationModel)));
  }
  function RemovalZoneCertificationModel() {
  }
  protoOf(RemovalZoneCertificationModel).k1y = function () {
    return this.d2o_1;
  };
  protoOf(RemovalZoneCertificationModel).y2f = function () {
    return this.e2o_1;
  };
  protoOf(RemovalZoneCertificationModel).h9 = function () {
    return this.f2o_1;
  };
  protoOf(RemovalZoneCertificationModel).d2d = function () {
    return this.g2o_1;
  };
  protoOf(RemovalZoneCertificationModel).v2h = function () {
    return this.h2o_1;
  };
  protoOf(RemovalZoneCertificationModel).w2h = function () {
    return this.i2o_1;
  };
  protoOf(RemovalZoneCertificationModel).s2State = function () {
    return this.e2o_1;
  };
  protoOf(RemovalZoneCertificationModel).s2Id = function () {
    return this.d2o_1;
  };
  protoOf(RemovalZoneCertificationModel).toString = function () {
    return 'RemovalZoneCertificationModel(id=' + this.d2o_1 + ', status=' + this.e2o_1 + ', name=' + this.f2o_1 + ', img=' + this.g2o_1 + ', creationDate=' + toString(this.h2o_1) + ', updatedDate=' + toString(this.i2o_1) + ')';
  };
  protoOf(RemovalZoneCertificationModel).hashCode = function () {
    var result = getStringHashCode(this.d2o_1);
    result = imul(result, 31) + this.e2o_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.f2o_1) | 0;
    result = imul(result, 31) + (this.g2o_1 == null ? 0 : this.g2o_1.hashCode()) | 0;
    result = imul(result, 31) + (this.h2o_1 == null ? 0 : this.h2o_1.hashCode()) | 0;
    result = imul(result, 31) + (this.i2o_1 == null ? 0 : this.i2o_1.hashCode()) | 0;
    return result;
  };
  protoOf(RemovalZoneCertificationModel).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RemovalZoneCertificationModel))
      return false;
    var tmp0_other_with_cast = other instanceof RemovalZoneCertificationModel ? other : THROW_CCE();
    if (!(this.d2o_1 === tmp0_other_with_cast.d2o_1))
      return false;
    if (!this.e2o_1.equals(tmp0_other_with_cast.e2o_1))
      return false;
    if (!(this.f2o_1 === tmp0_other_with_cast.f2o_1))
      return false;
    if (!equals(this.g2o_1, tmp0_other_with_cast.g2o_1))
      return false;
    if (!equals(this.h2o_1, tmp0_other_with_cast.h2o_1))
      return false;
    if (!equals(this.i2o_1, tmp0_other_with_cast.i2o_1))
      return false;
    return true;
  };
  function RemovalZoneCertificationPolicies() {
  }
  protoOf(RemovalZoneCertificationPolicies).canPage = function (authedUser) {
    return true;
  };
  protoOf(RemovalZoneCertificationPolicies).canGet = function (authedUser) {
    return true;
  };
  protoOf(RemovalZoneCertificationPolicies).canCreate = function (authedUser) {
    return hasRole(authedUser, 'Marque');
  };
  protoOf(RemovalZoneCertificationPolicies).canUpdate = function (authedUser, target) {
    // Inline function 'org.boislocal.platform.s2.commons.domain.model.canExecuteTransitionAnd' call
    var this_0 = S2_getInstance().b2n_1;
    var tmp;
    if (isAvailableTransition(this_0, target, ensureNotNull(getKClass(RemovalZoneCertificationUpdateCommand).z5()))) {
      // Inline function 'org.boislocal.platform.s2.removalZoneCertification.domain.policy.RemovalZoneCertificationPolicies.canUpdate.<anonymous>' call
      tmp = hasRole(authedUser, 'Marque');
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(RemovalZoneCertificationPolicies).canDelete = function (authedUser, target) {
    // Inline function 'org.boislocal.platform.s2.commons.domain.model.canExecuteTransitionAnd' call
    var this_0 = S2_getInstance().b2n_1;
    var tmp;
    if (isAvailableTransition(this_0, target, ensureNotNull(getKClass(RemovalZoneCertificationDeleteCommand).z5()))) {
      // Inline function 'org.boislocal.platform.s2.removalZoneCertification.domain.policy.RemovalZoneCertificationPolicies.canDelete.<anonymous>' call
      tmp = hasRole(authedUser, 'Marque');
    } else {
      tmp = false;
    }
    return tmp;
  };
  var RemovalZoneCertificationPolicies_instance;
  function RemovalZoneCertificationPolicies_getInstance() {
    return RemovalZoneCertificationPolicies_instance;
  }
  function RemovalZoneCertificationGetQueryDTO() {
  }
  function RemovalZoneCertificationGetResponseDTO() {
  }
  function RemovalZoneCertificationPageQueryDTO() {
  }
  function RemovalZoneCertificationPageResponseDTO() {
  }
  //region block: post-declaration
  defineProp(protoOf(RemovalZoneCertificationState), 'position', function () {
    return this.jr();
  }, function (value) {
    this.y2c(value);
  });
  defineProp(protoOf(RemovalZoneCertificationState), 'name', protoOf(RemovalZoneCertificationState).h9);
  defineProp(protoOf(RemovalZoneCertificationState), 'ordinal', protoOf(RemovalZoneCertificationState).i9);
  protoOf($serializer).xt = typeParametersSerializers;
  protoOf($serializer_0).xt = typeParametersSerializers;
  defineProp(protoOf(RemovalZoneCertificationCreateCommand), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(RemovalZoneCertificationCreateCommand), 'img', function () {
    return this.d2d();
  });
  protoOf($serializer_1).xt = typeParametersSerializers;
  defineProp(protoOf(RemovalZoneCertificationCreatedEvent), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(RemovalZoneCertificationCreatedEvent), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(RemovalZoneCertificationCreatedEvent), 'img', function () {
    return this.d2d();
  });
  defineProp(protoOf(RemovalZoneCertificationCreatedEvent), 'time');
  protoOf($serializer_2).xt = typeParametersSerializers;
  defineProp(protoOf(RemovalZoneCertificationDeleteCommand), 'id', function () {
    return this.k1y();
  });
  protoOf($serializer_3).xt = typeParametersSerializers;
  defineProp(protoOf(RemovalZoneCertificationDeletedEvent), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(RemovalZoneCertificationDeletedEvent), 'time');
  protoOf($serializer_4).xt = typeParametersSerializers;
  defineProp(protoOf(RemovalZoneCertificationImportCommand), 'item', function () {
    return this.q20();
  });
  protoOf($serializer_5).xt = typeParametersSerializers;
  defineProp(protoOf(RemovalZoneCertificationImportedEvent), 'item', function () {
    return this.q20();
  });
  defineProp(protoOf(RemovalZoneCertificationImportedEvent), 'time');
  protoOf($serializer_6).xt = typeParametersSerializers;
  defineProp(protoOf(RemovalZoneCertificationUpdateCommand), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(RemovalZoneCertificationUpdateCommand), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(RemovalZoneCertificationUpdateCommand), 'img', function () {
    return this.d2d();
  });
  protoOf($serializer_7).xt = typeParametersSerializers;
  defineProp(protoOf(RemovalZoneCertificationUpdatedEvent), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(RemovalZoneCertificationUpdatedEvent), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(RemovalZoneCertificationUpdatedEvent), 'img', function () {
    return this.d2d();
  });
  defineProp(protoOf(RemovalZoneCertificationUpdatedEvent), 'time');
  protoOf($serializer_8).xt = typeParametersSerializers;
  defineProp(protoOf(RemovalZoneCertificationModel), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(RemovalZoneCertificationModel), 'status', function () {
    return this.y2f();
  });
  defineProp(protoOf(RemovalZoneCertificationModel), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(RemovalZoneCertificationModel), 'img', function () {
    return this.d2d();
  });
  defineProp(protoOf(RemovalZoneCertificationModel), 'creationDate', function () {
    return this.v2h();
  });
  defineProp(protoOf(RemovalZoneCertificationModel), 'updatedDate', function () {
    return this.w2h();
  });
  //endregion
  //region block: init
  Companion_instance_0 = new Companion_0();
  Companion_instance_1 = new Companion_1();
  Companion_instance_2 = new Companion_2();
  Companion_instance_3 = new Companion_3();
  Companion_instance_4 = new Companion_4();
  Companion_instance_5 = new Companion_5();
  Companion_instance_6 = new Companion_6();
  Companion_instance_7 = new Companion_7();
  Companion_instance_8 = new Companion_8();
  RemovalZoneCertificationPolicies_instance = new RemovalZoneCertificationPolicies();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$removalZoneCertification = $org$boislocal$platform$s2.removalZoneCertification || ($org$boislocal$platform$s2.removalZoneCertification = {});
    var $org$boislocal$platform$s2$removalZoneCertification$domain = $org$boislocal$platform$s2$removalZoneCertification.domain || ($org$boislocal$platform$s2$removalZoneCertification.domain = {});
    var $org$boislocal$platform$s2$removalZoneCertification$domain$automate = $org$boislocal$platform$s2$removalZoneCertification$domain.automate || ($org$boislocal$platform$s2$removalZoneCertification$domain.automate = {});
    $org$boislocal$platform$s2$removalZoneCertification$domain$automate.RemovalZoneCertificationState = RemovalZoneCertificationState;
    $org$boislocal$platform$s2$removalZoneCertification$domain$automate.RemovalZoneCertificationState.values = values;
    $org$boislocal$platform$s2$removalZoneCertification$domain$automate.RemovalZoneCertificationState.valueOf = valueOf;
    defineProp($org$boislocal$platform$s2$removalZoneCertification$domain$automate.RemovalZoneCertificationState, 'Exists', RemovalZoneCertificationState_Exists_getInstance);
    defineProp($org$boislocal$platform$s2$removalZoneCertification$domain$automate.RemovalZoneCertificationState, 'Deleted', RemovalZoneCertificationState_Deleted_getInstance);
    defineProp($org$boislocal$platform$s2$removalZoneCertification$domain$automate.RemovalZoneCertificationState, 'Companion', Companion_getInstance);
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$removalZoneCertification = $org$boislocal$platform$s2.removalZoneCertification || ($org$boislocal$platform$s2.removalZoneCertification = {});
    var $org$boislocal$platform$s2$removalZoneCertification$domain = $org$boislocal$platform$s2$removalZoneCertification.domain || ($org$boislocal$platform$s2$removalZoneCertification.domain = {});
    var $org$boislocal$platform$s2$removalZoneCertification$domain$command = $org$boislocal$platform$s2$removalZoneCertification$domain.command || ($org$boislocal$platform$s2$removalZoneCertification$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$removalZoneCertification = $org$boislocal$platform$s2.removalZoneCertification || ($org$boislocal$platform$s2.removalZoneCertification = {});
    var $org$boislocal$platform$s2$removalZoneCertification$domain = $org$boislocal$platform$s2$removalZoneCertification.domain || ($org$boislocal$platform$s2$removalZoneCertification.domain = {});
    var $org$boislocal$platform$s2$removalZoneCertification$domain$command = $org$boislocal$platform$s2$removalZoneCertification$domain.command || ($org$boislocal$platform$s2$removalZoneCertification$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$removalZoneCertification = $org$boislocal$platform$s2.removalZoneCertification || ($org$boislocal$platform$s2.removalZoneCertification = {});
    var $org$boislocal$platform$s2$removalZoneCertification$domain = $org$boislocal$platform$s2$removalZoneCertification.domain || ($org$boislocal$platform$s2$removalZoneCertification.domain = {});
    var $org$boislocal$platform$s2$removalZoneCertification$domain$command = $org$boislocal$platform$s2$removalZoneCertification$domain.command || ($org$boislocal$platform$s2$removalZoneCertification$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$removalZoneCertification = $org$boislocal$platform$s2.removalZoneCertification || ($org$boislocal$platform$s2.removalZoneCertification = {});
    var $org$boislocal$platform$s2$removalZoneCertification$domain = $org$boislocal$platform$s2$removalZoneCertification.domain || ($org$boislocal$platform$s2$removalZoneCertification.domain = {});
    var $org$boislocal$platform$s2$removalZoneCertification$domain$command = $org$boislocal$platform$s2$removalZoneCertification$domain.command || ($org$boislocal$platform$s2$removalZoneCertification$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$removalZoneCertification = $org$boislocal$platform$s2.removalZoneCertification || ($org$boislocal$platform$s2.removalZoneCertification = {});
    var $org$boislocal$platform$s2$removalZoneCertification$domain = $org$boislocal$platform$s2$removalZoneCertification.domain || ($org$boislocal$platform$s2$removalZoneCertification.domain = {});
    var $org$boislocal$platform$s2$removalZoneCertification$domain$model = $org$boislocal$platform$s2$removalZoneCertification$domain.model || ($org$boislocal$platform$s2$removalZoneCertification$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$removalZoneCertification = $org$boislocal$platform$s2.removalZoneCertification || ($org$boislocal$platform$s2.removalZoneCertification = {});
    var $org$boislocal$platform$s2$removalZoneCertification$domain = $org$boislocal$platform$s2$removalZoneCertification.domain || ($org$boislocal$platform$s2$removalZoneCertification.domain = {});
    var $org$boislocal$platform$s2$removalZoneCertification$domain$policy = $org$boislocal$platform$s2$removalZoneCertification$domain.policy || ($org$boislocal$platform$s2$removalZoneCertification$domain.policy = {});
    defineProp($org$boislocal$platform$s2$removalZoneCertification$domain$policy, 'RemovalZoneCertificationPolicies', RemovalZoneCertificationPolicies_getInstance);
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$removalZoneCertification = $org$boislocal$platform$s2.removalZoneCertification || ($org$boislocal$platform$s2.removalZoneCertification = {});
    var $org$boislocal$platform$s2$removalZoneCertification$domain = $org$boislocal$platform$s2$removalZoneCertification.domain || ($org$boislocal$platform$s2$removalZoneCertification.domain = {});
    var $org$boislocal$platform$s2$removalZoneCertification$domain$query = $org$boislocal$platform$s2$removalZoneCertification$domain.query || ($org$boislocal$platform$s2$removalZoneCertification$domain.query = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$removalZoneCertification = $org$boislocal$platform$s2.removalZoneCertification || ($org$boislocal$platform$s2.removalZoneCertification = {});
    var $org$boislocal$platform$s2$removalZoneCertification$domain = $org$boislocal$platform$s2$removalZoneCertification.domain || ($org$boislocal$platform$s2$removalZoneCertification.domain = {});
    var $org$boislocal$platform$s2$removalZoneCertification$domain$query = $org$boislocal$platform$s2$removalZoneCertification$domain.query || ($org$boislocal$platform$s2$removalZoneCertification$domain.query = {});
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  _.$_$ = _.$_$ || {};
  _.$_$.a = $serializer_getInstance_9;
  //endregion
  return _;
}));

//# sourceMappingURL=boislocal-platform-platform-s2-referential-removalZoneCertification-removalZoneCertification-domain.js.map
